import { render, staticRenderFns } from "./RelatorioTableView.vue?vue&type=template&id=ad8872ae"
import script from "./RelatorioTableView.vue?vue&type=script&lang=js"
export * from "./RelatorioTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports